import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  item: {
    position: 'relative',
    width: '100%',
    // Keeps each card's own margins inside its wrapper, so a collapsed card can't leak or lose spacing
    display: 'flow-root',
    // A card whose component rendered nothing (e.g. no agent found) gets no handle or spacing
    '&:has(> $content:empty)': {
      display: 'none'
    },
    '&:hover $control, & $control:focus-visible': {
      opacity: 1
    }
  },
  dragging: {
    zIndex: 1,
    opacity: 0.85
  },
  controls: {
    position: 'absolute',
    top: 0,
    left: -theme.spacing(8),
    zIndex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1)
  },
  control: {
    display: 'flex',
    padding: 2,
    border: 'none',
    borderRadius: 4,
    background: theme.colorPalette.beige_50,
    color: theme.colorPalette.green_80,
    cursor: 'pointer',
    opacity: 0.6
  },
  handle: {
    cursor: 'grab',
    '&:active': {
      cursor: 'grabbing'
    }
  },
  // Cancels CollapsibleCard's shadow padding and bottom margin so a collapsed bar keeps the sidebar's own spacing
  collapsedBar: {
    marginTop: -3,
    marginBottom: -8
  },
  content: {},
  hidden: {
    display: 'none'
  }
}));

export default useStyles;
